import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Navbar() {
    const location = useLocation();
    const navigate = useNavigate();
    const username = localStorage.getItem('username');

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        navigate('/login');
    };

    return (
        <nav className="navbar">
            <div className="navbar-logo">💸 ExpenseFlow</div>
            <div className="navbar-links">
                <Link
                    to="/dashboard"
                    className={location.pathname === '/dashboard' ? 'active' : ''}
                >
                    Dashboard
                </Link>
                <Link
                    to="/report"
                    className={location.pathname === '/report' ? 'active' : ''}
                >
                    Reports
                </Link>
                <span style={{ color: 'var(--text2)', fontSize: '0.88rem', marginLeft: '8px' }}>
                    Hi, {username} 👋
                </span>
                <button className="btn-logout" onClick={logout}>
                    Logout
                </button>
            </div>
        </nav>
    );
}

export default Navbar;